import Table, { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import {
  IMoneyReceiptDetails,
  IMoneyReceiptSingleDataType,
  IReceiptAddInvoice,
} from '../../Types/MoneyReceiptTypes';
import dayjs from 'dayjs';
import {
  useAddInvoiceInReceiptMutation,
  useGetMoneyReceiptDetailsQuery,
} from '../../api/endpoints/moneyReceiptEndpoints';
import FormHeaderTitle from '../../../Invoice(Visa)/Components/FormHeaderTitle';
import { Button, Card, Col, Flex, Form, message, Modal, Row, Space } from 'antd';
import { DateInput } from '../../../../components/common/FormItem/FormItems';
import { PlusOutlined } from '@ant-design/icons';
import NewMoneyReceiptSpecificInvoice from '../../Components/NewMoneyReceiptSpecificInvoice';

type Props = {
  id: string | undefined;
  cashiercomponentRef: React.RefObject<HTMLDivElement>;
  moneyReceipt: IMoneyReceiptSingleDataType;
};
const MoneyReceiptDetails = (props: Props) => {
  const id = props.id;
  const [form] = Form.useForm();
  const { cashiercomponentRef, moneyReceipt } = props;
  const [open, setOpen] = useState(false);
  const client_id = moneyReceipt?.comb_client;
  const paymentTo = moneyReceipt?.receipt_payment_to;
  const invoices = Form.useWatch('invoices', form);
  const [addInvoice, { isSuccess, isLoading }] = useAddInvoiceInReceiptMutation();
  const { data } = useGetMoneyReceiptDetailsQuery(String(id));

  const moneyReceiptTotal = Number(moneyReceipt?.receipt_total_amount) || 0;
  const invoiceClientTotal = data?.data?.reduce((acc: number, item: IMoneyReceiptDetails) => {
    return acc + Number(item.invclientpayment_amount);
  }, 0);

  const formInvoiceTotal = invoices?.reduce((acc: number, item: any) => {
    return acc + Number(item?.invoice_amount || 0);
  }, 0);

  const receiptRemainingTotal = moneyReceiptTotal - (invoiceClientTotal || 0);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const onFinish = (values: any) => {
    if (receiptRemainingTotal < formInvoiceTotal) {
      message.error('Invoice Amount can not greater than Receipt Remaining Total');
      return;
    }
    const { payment_date, invoices } = values;
    const data: IReceiptAddInvoice = {
      payment_date: dayjs(payment_date).format('YYYY-MM-DD'),
      invoices: invoices?.map((item: any) => ({
        invoice_id: item.invoice_no,
        payment_amount: item.invoice_amount,
      })),
    };
    addInvoice({ data, receipt_id: Number(id) });
  };

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      message.success('Invoice Added Successfully');
      form.resetFields();
    }
  }, [isSuccess]);

  const moneyReceiptCostColumn: ColumnsType<IMoneyReceiptDetails> = [
    {
      title: 'SL',
      render: (_, data, index) => <> {index + 1} </>,
    },
    {
      title: 'Payment Date',
      key: 'invclientpayment_date',
      dataIndex: 'invclientpayment_date',
      render: (data) => <>{dayjs(data.invclientpayment_date).format('DD-MM-YYYY')}</>,
    },
    {
      title: 'Invoice No',
      key: 'invoice_no',
      dataIndex: 'invoice_no',
    },
    {
      title: 'Sales Date',
      key: 'invoice_sales_date',
      dataIndex: 'invoice_sales_date',
      render: (data) => <>{dayjs(data.invoice_sales_date).format('DD-MM-YYYY')}</>,
    },
    {
      title: 'Payment Amount',
      key: 'invclientpayment_amount',
      dataIndex: 'invclientpayment_amount',
    },
    {
      title: 'Invoice Amount',
      key: 'invoice_net_total',
      dataIndex: 'invoice_net_total',
    },
  ];

  return (
    <div
      ref={cashiercomponentRef}
      className='my-20'
      style={{ backgroundColor: '#FFFFFF', padding: '20px', minWidth: '100vh' }}
    >
      <Row>
        <Col span={21}>
          <FormHeaderTitle title='RECEIPT DETAILS' />
        </Col>
        {paymentTo === 'ADVANCE' && (
          <Col span={3} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <Button onClick={showModal} type='primary'>
              Add Invoice
            </Button>
          </Col>
        )}
      </Row>
      <Modal
        forceRender
        width={1000}
        style={{ top: 20 }}
        title='Add Invoice'
        open={open}
        onOk={handleOk}
        footer={null}
        // okButtonProps={{ loading: isLoading }}
        onCancel={handleCancel}
      >
        <Form
          layout='vertical'
          onFinish={onFinish}
          onFinishFailed={() => message.error('Submission Failed')}
          form={form}
          initialValues={{
            payment_date: dayjs(),
          }}
        >
          <Flex>
            <DateInput
              mdSize={24}
              smSize={24}
              required
              label='Payment Date:'
              name={'payment_date'}
            />
            <p
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '20px',
                marginLeft: '12px',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
            >
              Remaining Amount : {receiptRemainingTotal}
            </p>
          </Flex>
          <Card style={{ margin: '10px 0px' }}>
            <Form.List name='invoices' initialValue={[{}]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }, index) => (
                    <NewMoneyReceiptSpecificInvoice
                      fields={fields}
                      key={key}
                      name={name}
                      remove={remove}
                      selectClient={1} // for enable invoice field
                      paymentTo={'INVOICE'}
                      index={index}
                      form={form}
                      reason={'ADD_NEW'}
                      client_id={client_id}
                    />
                  ))}
                  <Button
                    style={{ width: '110px', borderRadius: '3px' }}
                    onClick={() => add()}
                    size='small'
                    block
                    icon={<PlusOutlined />}
                  >
                    Add field
                  </Button>
                </>
              )}
            </Form.List>
          </Card>

          <Button type='primary' htmlType='submit' loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
      <Table
        size='small'
        bordered
        rowKey={(e) => e.invclientpayment_amount}
        className='invoiceBillingTable'
        rowClassName={'invoiceBillingTd'}
        dataSource={data?.data}
        columns={moneyReceiptCostColumn}
        pagination={false}
        style={{ marginBottom: '20px' }}
      />
    </div>
  );
};

export default MoneyReceiptDetails;
